import {callApi} from '@/api/api-core'

export const GetAllActiveNotifications = function(){
    return callApi('GET', 'api/notification/get', null)
}